import { render } from "./ItemDeQuestaoSelecao.vue?vue&type=template&id=3c39e7aa&ts=true"
import script from "./ItemDeQuestaoSelecao.vue?vue&type=script&lang=ts"
export * from "./ItemDeQuestaoSelecao.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__